export const DEFAULT_TITLE = "deeple";
export const UNSEEN_NOTIFICATION_COUNT_LIMIT = 99;
